import React from "react";
// Limitless imports
import BoxRenderer from "../box-renderer/BoxRenderer";
import { renderDefaultCell } from "../../utils/table-cell-renderers/TableCellRenderers";
import { getFormattedColumns, generateTableData } from "../../utils/TableDataGenerator";
const TYPE_MAP = {
  responded: "Responded",
  escalated: "Forwarded",
  reviewed: "Reviewed"
};
const renderBoxCell = (value, t) => {
  return /*#__PURE__*/React.createElement(BoxRenderer, {
    fontSize: 11,
    fontWeight: 900,
    value: t(value === "resolved" ? "REVIEW COMPLETE, AWAITING PAYMENT" : "IN PROGRESS"),
    color: value === "resolved" ? "green" : "orange",
    variant: "outlined",
    showRadius: false,
    containerStyles: {
      paddingTop: 4,
      paddingBottom: 4
    }
  });
};
const getCenterAlignedCellProps = cellWidth => {
  return {
    customBodyRender: v => renderDefaultCell(v, null, null, false, "center"),
    setCellProps: () => {
      return {
        style: {
          width: cellWidth
        }
      };
    },
    setCellHeaderProps: () => ({
      style: {
        textAlign: "center"
      }
    })
  };
};
const getPendingPaymentColumns = (formatDateFunc, t) => ({
  Group: {
    fieldKey: "groupName",
    columnOptions: {
      searchable: false,
      customBodyRender: renderDefaultCell,
      setCellProps: () => {
        return {
          style: {
            minWidth: 100
          }
        };
      }
    }
  },
  Type: {
    fieldExtractor: function getTypeData(data) {
      const type = TYPE_MAP[data.type];
      return type ? t(type) : data.type;
    },
    columnOptions: {
      searchable: false,
      customBodyRender: renderDefaultCell,
      setCellProps: () => {
        return {
          style: {
            minWidth: 100
          }
        };
      }
    }
  },
  Status: {
    fieldKey: "lifecycleState",
    columnOptions: {
      searchable: false,
      customBodyRender: v => renderBoxCell(v, t),
      setCellProps: () => {
        return {
          style: {
            width: 235
          }
        };
      }
    }
  },
  "Number of Contributors": {
    fieldExtractor: data => data.contributorsCount ? `${data.contributorsCount}` : "0",
    columnOptions: {
      searchable: false,
      filter: false,
      ...getCenterAlignedCellProps(145)
    }
  },
  "Fee Available": {
    fieldExtractor: data => data.fee ? data.fee : "-",
    columnOptions: {
      searchable: false,
      filter: false,
      sort: false,
      ...getCenterAlignedCellProps(85)
    }
  },
  "Fee Allocation Date": {
    fieldKey: "expectedPaymentDate",
    columnOptions: {
      searchable: false,
      filter: false,
      sort: false,
      ...getCenterAlignedCellProps(115),
      customBodyRender: value => renderDefaultCell(value ? formatDateFunc(value) : "-", null, null, false, "center")
    }
  }
});
export const getPendingQuestionHistoryTableData = (pendingQuestionHistory, formatDateFunc, t) => {
  const columns = getPendingPaymentColumns(formatDateFunc, t);
  return {
    columns: getFormattedColumns(columns, t),
    data: generateTableData(columns, pendingQuestionHistory)
  };
};